"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var schemas_1 = require("@dcl/schemas");
require("./NotificationItemImage.css");
function NotificationItemImage(_a) {
    var rarity = _a.rarity, url = _a.url, backgroundColor = _a.backgroundColor, icon = _a.icon;
    var bgColor = rarity
        ? schemas_1.Rarity.getGradient(rarity).join()
        : backgroundColor
            ? backgroundColor
            : null;
    return (react_1.default.createElement("div", { className: "dcl notification-image__container" },
        react_1.default.createElement("div", { className: "dcl notification-image", style: {
                backgroundImage: "radial-gradient(".concat(bgColor, ")")
            } },
            react_1.default.createElement("img", { src: url, alt: "Notification Image" })),
        icon && react_1.default.createElement("span", { className: "dcl notification-icon" }, icon)));
}
exports.default = NotificationItemImage;
